module.exports = __webpack_public_path__ + "static/accounting-5f8c1033f1a6be777c7d00a7400a8217.png";